import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConfirmationDialogService } from 'src/app/test/test-step/confirmation-dialog.service';
import { ProjectService } from 'src/app/_services/project.service';
import { ReportService } from 'src/app/_services/report.service';
// import * as moment from 'moment';
import { Moment } from 'moment';
import moment from 'moment-timezone';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { UrlService } from 'src/app/_services/url.service';
import { MemoryService } from 'src/app/_services/memory.service';
import { HomeService } from 'src/app/_services/home.service';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
  providers: [DatePipe]
})
export class HistoryComponent implements OnInit {
  public tzNames: string[];
  public selectedTz: string;
  public utcDate: moment.Moment;
  public tzDate: moment.Moment;
  currentDate: Date;
  myDate = new Date();
  projectId: any;
  locatorReportData: any;
  projectData: Object;
  projectName: any;
  count: Number = 10;
  locatorLogDataS: {};
  locatorLogData: any;
  resultCount = ["10","20","30","40","50"];
  enableCheckBox: boolean = true;
  indexFormArray: UntypedFormArray;
  form:UntypedFormGroup;
  enableLocatorTab: boolean = false;
  disableHistoryTab: boolean = true;
  ids=["",""];
  ids1: any;
  searchString: string;
  locatorReportDataForList1: any;
  locatorReportDataForList2: any;
  list1: any;
  list2: any;
  item: object;
  jsonToBeUsed: any[];
  jsonToBeUsedForList1: any[];
  jsonToBeUsedForList2: any[];
  dataForDateRange: any;
  toDate:  any;
  fromDate: any;
  testLogDataS: any;
  url: string;
  testSuiteFileData: any;
  suiteName: any;
  suiteData: any;
  test1: any;
  dataForComparison: any[];
  enableTaskChangeTab: boolean;
  locatorReportTableData: any;
  locatorReportDataCopy: any;
  headerOptions = {
    showSetting : true,
    showSearch: false,
    heading : 'History Report',
    data: undefined,
  }
  previousUrl: any=[];
  currentUrl: any;
  previousUrltemp: any;
  agentCheck: boolean;
  
  constructor(
  private report: ReportService,
  private project: ProjectService,
  private formBuilder: UntypedFormBuilder,
  private http: HttpClient,
  private datepipe: DatePipe,
  private route: ActivatedRoute,
  private _router: Router,
  private toastrService:ToastrService,
  private urlService:UrlService,
  private memoryService: MemoryService,
  private homeService: HomeService,
  private confirmationDialogService:ConfirmationDialogService,
  @Inject( DOCUMENT ) private document: Document,
  ) { 
    this.url = environment.baseUrl;
    this.form = this.formBuilder.group({
      checkArray: this.formBuilder.array([])
    })
    this.tzNames = moment.tz.names();
    this.test1 = this.datepipe.transform(this.myDate, 'yyyy-MM-dd');
    this.timeZoneChanged('Asia/Calcutta');
  }
  
  @ViewChild('locatorChanges',null) locatorChanges: ElementRef;
  @ViewChild('taskChange',null) taskChange: ElementRef;
  @ViewChild('processHIstory',null) processHistory: ElementRef;
  //taskChange
countChange(value){
this.count = value;
// this.loadLocator(this.fromDate,this.toDate,this.count);
}
  ngOnInit() {
    this.memoryService.getAgentCheck().subscribe((res) => {
      this.agentCheck = res;
    })
    this.initFromToDate();
    this.route.paramMap.subscribe(
      params => {
        this.projectId = params.get('pid');
        this.project.getProjectById(this.projectId).subscribe(
          (data) => {
            this.projectData = data;
            this.headerOptions.data = {
              projectId: this.projectId,
              projectName: data['projectName']
            };
            //set header details
            this.homeService.setHeaderOptions(this.headerOptions);

            this.getTestFileData();
            setTimeout(() => {
              this.loadLocator(this.fromDate, this.toDate, this.count);
            }, 1000);
          }
        )

      }
    )
    if (this.agentCheck) {
      this.memoryService.getUrlHistory().subscribe((res) => {
        this.previousUrl = res;
        if (this.previousUrl.length > 0) {
          this.currentUrl = this._router.url;
          this.previousUrltemp = this.urlService.captureUrl(this.currentUrl);
          this.memoryService.setUrlHistory(this.previousUrltemp);
        }
      })
    }
    else {
      this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      if (!this.previousUrl) {
        this.currentUrl = this._router.url;
        this.previousUrltemp = this.urlService.captureUrl(this.currentUrl);
        localStorage.setItem('urlHistory', JSON.stringify(this.previousUrltemp));
        this.previousUrl = JSON.parse(localStorage.getItem("urlHistory"));
      }
    }
  }
  geturlName(url) {
    return this.urlService.geturlName(url);
  }
getTestFileData(){
 this.http.get(this.url+'/HuLoopRest/huloop/test/all/' +this.projectId).subscribe(
   (data)=>{
     this.testSuiteFileData = data['testSuiteFileData']
   
   }
 )
}
getTestNodeById(obj){
 this.suiteData = this.testSuiteFileData.filter((f)=>f.id==obj);
 this.suiteName = this.suiteData[0].title;
 return this.suiteName;
}

loadTestHistory = function (loggingList) {
 
      this.testLogDataS = {};
      if (loggingList) {
          for (var i = 0; i < loggingList.length; i++) {
              var loggingData = loggingList[i];
              var obj = JSON.parse(loggingData.entity);
              if (obj) {
                  loggingData.title = new Object();
                  loggingData.title = obj.title;
                  if (obj.parentTestDataId) {
                      var parentModule = this.getTestNodeById(obj.parentTestDataId);;
                      loggingData.testsuite = parentModule ? parentModule.title : '';
                  }
                  loggingData.steps = obj.testStepList || [];
                  loggingData.isSelected = false;
                  this.testLogDataS[loggingData.id] = loggingData;
              }
          }
      }
      
  
  
};
loadLocator(fromDate,toDate,count, fromFilter?:boolean){

  let fDate;
  let tDate; 
  if(fromFilter){
  fDate = Math.floor(new Date(fromDate).getTime());
   tDate =   Math.floor(new Date(toDate ).getTime());
  }
 else{
  fDate = Math.floor(new Date(fromDate).getTime());
  tDate =   Math.floor(new Date(toDate +" 23:59:59").getTime()); 
 }

  this.report.getTestHistory(this.projectId,fDate,tDate,count).subscribe((
    data=>{
   
      this.locatorReportData=data['loggingList'];
      if(!this.locatorReportData)
      {
          this.toastrService.clear();
          this.toastrService.info("No Records found, please change the date and try again ");
      }
      // this.loadTestHistory(data['loggingList']);
      console.log(this.locatorReportData);
      
      for (var i = 0; i < this.locatorReportData.length; i++) {
        this.locatorLogData = this.locatorReportData[i];
        if(!this.locatorLogData.entity){
          this.locatorLogData.entity = ''
        }
        if(this.locatorLogData.entity){
          var obj = JSON.parse(this.locatorLogData.entity);
          if (obj) {
            this.locatorLogData.title = new Object();
            this.locatorLogData.title = obj.title;
              if (obj.parentTestDataId) {
                  var parentModule = this.getTestNodeById(obj.parentTestDataId);
                  this.locatorLogData.testsuite = parentModule;
              }
              this.locatorLogData.steps = obj.testStepList || [];
              this.locatorLogData.isSelected = false;
              this.locatorReportData[this.locatorLogData.id] = this.locatorLogData;
          }
        }
       
        //console.log(obj)
      
    }

    this.locatorReportTableData =  JSON.parse(JSON.stringify(this.locatorReportData))
    this.locatorReportDataCopy = JSON.parse(JSON.stringify(this.locatorReportData))

this.locatorReportData.map((element,index) => {
let time = moment(element.date, "x").tz(this.selectedTz).format(" MMM DD YYYY hh:mm a");
element.date = time;
});
    //console.log(this.locatorReportData);
       
    }
  ))
}

sendScreenName(screen){
 const sameScreenName =  this.locatorReportData.filter((f)=>f.screen==screen);
 //console.log(sameScreenName);
if(screen){

}
//console.log(screen);
this.enableCheckBox = false
}

onChange(screen:string, id,isChecked: boolean) {
  this.indexFormArray = <UntypedFormArray>this.form.controls.checkArray;

  if(isChecked) {
    this.locatorReportData =  this.locatorReportData.filter((f)=>f.entityTitle==screen);
    if(this.indexFormArray.value.length< 2){
      this.toastrService.clear();
      this.toastrService.info('select second to compare');
    }
   
    //console.log(this.indexFormArray.value.length)
    //console.log(this.indexFormArray.value);
     

    this.indexFormArray.push(new UntypedFormControl(screen));
    this.indexFormArray.push(new UntypedFormControl(id));
    //console.log(this.indexFormArray.value);
     if(this.indexFormArray.value.length == 4){
      this.toastrService.clear();
      //console.log(this.indexFormArray.value);
      this.ids[0] = this.indexFormArray.value[1];
      this.ids[1] = this.indexFormArray.value[3];
      
      this.locatorReportDataForList1 = this.locatorReportData.filter((f)=>f.id==this.ids[0]);
      this.locatorReportDataForList2 = this.locatorReportData.filter((f)=>f.id==this.ids[1]);
      //console.log(this.locatorReportDataForList1)
      //console.log(this.locatorReportDataForList2)
      this.list1 =  this.locatorReportDataForList1[0].list;
      this.list2 =  this.locatorReportDataForList2[0].list;
      // //console.log('list1>>',this.list1);
      // //console.log('list2>>',this.list2);
   
      // //console.log( '1',this.locatorReportDataForList1);
      // //console.log( '2',this.locatorReportDataForList2);
      // //console.log(this.ids,'>>');

this.jsonToBeUsedForList1 = [];

for (var type in  this.list1) {
    this.item = {};
    this.item['key'] = type;
    this.item['value'] =  this.list1[type];
    this.jsonToBeUsedForList1.push(this.item);
}
//console.log(this.jsonToBeUsedForList1);


this.jsonToBeUsedForList2 = [];

for (var type in  this.list2) {
    this.item = {};
    this.item['key'] = type;
    this.item['value'] =  this.list2[type];
    this.jsonToBeUsedForList2.push(this.item);
}

    this.enableLocatorTab = true;
    this.disableHistoryTab = false;
    this.enableTaskChangeTab=true;
    // this.locatorChanges.nativeElement.click();
    setTimeout(() => {
      
      this.showTestChanges(this.ids[0],this.ids[1]);
      this.taskChange.nativeElement.click();
    }, 0);
 }
  } else {
    let Index = this.indexFormArray.controls.findIndex(x => x.value == screen)
    this.indexFormArray.removeAt(Index);
    //console.log(this.indexFormArray.value)
  }
}
testCompare = function (previous, next) {
  var compare = new Object();
  compare['type'] = previous.type === next.type ? true : false;
  compare['skip'] = previous.active === next.active ? true : false;
  compare['name'] = previous.name === next.name ? true : false;
  compare['pageName'] = previous.pageName === next.pageName ? true : false;
  compare['elementKey'] = previous.elementKey === next.elementKey ? true : false;
  compare['parameters'] = previous.parameters === next.parameters ? true : false;
  compare['equal'] = compare['type'] && compare['skip'] && compare['name'] && compare['pageName'] && compare['elementKey'] && compare['parameters'];
  return compare;
}

showTestChanges(index, indexToCompare) {

  // var loading = true;
  console.log(this.locatorReportData);
  var testReportData = JSON.parse(JSON.stringify(this.locatorReportData))
  var testLog =testReportData.filter((f)=>f.id==index);
  var next = testLog[0].steps;
  var nextDate = testLog[0].date;

  var testLogPrev = testReportData.filter((f)=>f.id==indexToCompare);
  var prev = testLogPrev[0].steps;
  var prevDate = testLogPrev[0].date;

  var prevLength = prev.length;
  var nextLength = next.length;

  var mergeData = new Array();

  var length = prevLength > nextLength ? nextLength : prevLength;

  for (var i = 0; i < length; i++) {
      var pushData = new Object();
      pushData['prevData'] = prev[i];
      pushData['nextData'] = next[i];
      pushData['compare'] = this.testCompare(pushData['prevData'], pushData['nextData']);
      mergeData.push(pushData);
  }

  for (let i = length; i < prevLength; i++) {
      var pushData = new Object();
      pushData['prevData'] = prev[i];
      pushData['nextData'] = {
          "type": "",
          "skip": "",
          "name": "",
          "pageName": "",
          "elementKey": "",
          "parameters": ""
      };
      pushData['compare'] = this.testCompare(pushData['prevData'], pushData['nextData']);
      mergeData.push(pushData);
  }
  for (let i = length; i < nextLength; i++) {
      var pushData = new Object();
      pushData['prevData'] = {
          "type": "",
          "skip": "",
          "name": "",
          "pageName": "",
          "elementKey": "",
          "parameters": ""
      };
      pushData['nextData'] = next[i];
      pushData['compare'] = this.testCompare(pushData['prevData'], pushData['nextData']);
      mergeData.push(pushData);
  }
  console.log(mergeData);
  this.dataForComparison = mergeData;
  // $rootScope.loading = false;
  // $scope.openTestModal();
};

onFilterLocatorHistory(updateLocatorHistoryForm){
  //console.log(updateLocatorHistoryForm.value)
  //console.log(this.fromDate);
  //console.log(this.toDate);
  let fromDate = Math.floor(new Date(updateLocatorHistoryForm.value.fromDate).getTime());
  let toDate =   Math.floor(new Date(updateLocatorHistoryForm.value.toDate +" 23:59:59").getTime());
  let e = new Date(this.test1 +" 23:59:59").getTime();
  // console.log(e);
  fromDate = new Date(updateLocatorHistoryForm.value.fromDate).getTime();
  toDate =   new Date(updateLocatorHistoryForm.value.toDate +" 23:59:59").getTime();
  // console.log(this.fromDate);
  // console.log(this.toDate);
  if(fromDate > e || toDate > e)
  {
    this.toastrService.info('Please select current or past date');
  }else {
  fromDate = Math.floor(new Date(updateLocatorHistoryForm.value.fromDate).getTime());
  toDate =   Math.floor(new Date(updateLocatorHistoryForm.value.toDate + " 23:59:59").getTime());
  if(toDate < fromDate){
    this.toastrService.info('Please select end date after start date');
  }
  else {
  //console.log('from',this.fromDate , 'to', this.toDate);
  this.loadLocator(fromDate,toDate,this.count,true);
  }
  }
  // this.loadLocator(this.count);
  // this.locatorReportData = this.locatorReportData.filter(e=> e.date >= this.fromDate && e.date <= this.toDate);
  // //console.log(this.locatorReportData);
}
applyDateFilter() {
  //console.log(this.form);
 
  this.dataForDateRange = this.locatorReportData.filter(e=> e.date >= this.form.value.fromDate && e.date <= this.form.value.toDate);
}

closeChange(){
  this.enableLocatorTab = false;
    this.disableHistoryTab = true;
    this.refreshPage();
}
refreshPage() {
  this.document.defaultView.location.reload();
}



public timeZoneChanged(timeZone: string): void {
  //console.log(timeZone, this.locatorReportDataCopy, this.locatorReportData);
  if(this.locatorReportDataCopy)
  {
    this.locatorReportData = JSON.parse(JSON.stringify(this.locatorReportDataCopy));
    //console.log(this.locatorReportData, this.locatorReportDataCopy)
  }
  
  if(this.locatorReportData)
  {
        this.locatorReportData.map((element,index) => {
          // let time1 = moment(element.date, "x").tz(timeZone).unix();
          let time = moment(element.date, "x").tz(timeZone).format(" MMM DD YYYY hh:mm a");
          // //console.log(time, element.date, time1)
          element.date = time;
          //element.date = time;
         });
         //console.log("-----------------------------------------------------");
  }

  ////console.log(this.locatorReportData);

  this.tzDate = moment('Mar 24, 2022 14:46:40').tz(timeZone);
  this.selectedTz = timeZone;

 // this.updateTime(timeZone);
}

private updateTime(timeZone: string) {
  const currentTime = new Date().getTime();
  this.utcDate = moment(currentTime).utc();
  this.tzDate = moment(currentTime).tz(timeZone);

}
getContentClassByTestType = function (type) {
  var icon = '';
  if (type === 'AUTOMATIC') {
    icon = 'fa fa-check';
  } else if (type === 'MANUAL') {
    icon = 'fa fa-pencil';
  }
  return icon;
}
resetHistory(){
  console.log('clicked reset');
  
  this.reloadComponent()
}

reloadComponent() {
  let currentUrl = this._router.url;
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
      this._router.navigate([currentUrl]);
  }


  initFromToDate()
  {
    var today = new Date();
    var year = today.getFullYear();
    var month = String(today.getMonth() + 1).padStart(2,"0");
    var date  =  String(today.getDate()).padStart(2,"0")
    this.toDate = year + "-" + month + "-" + date;
    
    const now = new Date();
    var lastWeek = new Date(now.getFullYear(), now.getMonth(),1);
    var year1 = lastWeek.getFullYear();
    var month1 = String(lastWeek.getMonth() + 1).padStart(2,"0");
    var date1  =  String(lastWeek.getDate()).padStart(2,"0")
    this.fromDate = year1 + "-" + month1 + "-" + date1;
  }
}
